<cx-generic-link *ngIf="data" [url]="data.url" [style]="data.styleAttributes" [target]="getTarget(data)">
  <div [class]="styleClasses">
    <i *ngIf="hasClass('arrow-right')" nz-icon nzType="arrow-right"></i>
    {{ data.linkName }}
    <i *ngIf="hasClass('btn-link')" nz-icon nzType="arrow-right"></i>
  </div>
</cx-generic-link>
